 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Contra Journal No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 v-show="action !== 'jrnlNoTxn'">
        <form data-vv-scope="queryContraJrnlNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg4 md6 xs12>
                          <v-text-field
                            data-vv-scope="queryContraJrnlNoFilterForm"
                            v-model="filtersContraJrnlNo.contraJrnlNo"
                            :label="filtersContraJrnlNoLabel.contraJrnlNo"
                            :error-messages="errors.collect('filterContraJrnlNo')"
                            data-vv-name="filterContraJrnlNo"
                            :data-vv-as="filtersContraJrnlNoLabel.contraJrnlNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md6 xs12>
                          <v-text-field
                            data-vv-scope="queryContraJrnlNoFilterForm"
                            v-model="filtersContraJrnlNo.contDocNo"
                            :label="filtersContraJrnlNoLabel.contDocNo"
                            :error-messages="errors.collect('filterContraJrnlNo')"
                            data-vv-name="filterContraJrnlNo"
                            :data-vv-as="filtersContraJrnlNoLabel.contDocNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md6 xs12>
                          <v-text-field
                            data-vv-scope="queryContraJrnlNoFilterForm"
                            v-model="filtersContraJrnlNo.documentNo"
                            :label="filtersContraJrnlNoLabel.documentNo"
                            :error-messages="errors.collect('filterContraJrnlNo')"
                            data-vv-name="filterContraJrnlNo"
                            :data-vv-as="filtersContraJrnlNoLabel.documentNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearContraJrnlNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doContraJrnlNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="contraJrnlNoHeaders"
          :items="contraJrnlNoItems"
          v-bind:options.sync="paginationContraJrnlNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsContraJrnlNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.mdJrnl }}</td>
              <td>{{ row.item.mdContDocNo }}</td>
              <td>{{ row.item.mdDocNo }}</td>
              <td>{{ row.item.mdAcctNo }}</td>
              <td>{{ row.item.mdBranch }}</td>
              <td>{{ row.item.mdFund }}</td>
              <td>{{ row.item.mdTranType }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignContraJrnlNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      actionName: '',
      filtersContraJrnlNoLabel: {
        contraJrnlNo: 'Contra Journal No.',
        contDocNo: 'Contra Doc No.',
        documentNo: 'Document No.'
      },
      filtersContraJrnlNo: {
        contraJrnlNo: undefined,
        contDocNo: undefined,
        documentNo: undefined,
        contBrn: undefined,
        contTranType: undefined,
        contAcctNo: undefined,
        contFund: undefined,
        contAcctNoSfx: undefined,
        actionName: undefined
      },
      contraJrnlNoItems: [],
      totalItemsContraJrnlNo: 0,
      contraJrnlNoHeaders: [
        { text: 'Contra Journal No.', align: 'left', value: 'mdJrnl' },
        { text: 'Contra Doc No.', align: 'left', value: 'mdContDocNo' },
        { text: 'Doc No.', align: 'left', value: 'mdDocNo' },
        { text: 'Account No.', align: 'left', value: 'mdAcctNo' },
        { text: 'Branch', align: 'left', value: 'mdBranch' },
        { text: 'Fund', align: 'left', value: 'mdFund' },
        { text: 'Tran Type', align: 'left', value: 'mdTranType' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationContraJrnlNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doInit()
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doInit()
      }
    },
    'paginationContraJrnlNo': function (value) {
      this.fetchContraJrnlNoData()
    }
  },
  methods: {
    async doInit() {
      if (this.action === 'jrnlNoTxn') {
        if (this.matchData !== null) {
          this.filtersContraJrnlNo.contraJrnlNo = this.matchData.mdJrnl
          this.filtersContraJrnlNo.contDocNo = this.matchData.mdDocNo
          this.filtersContraJrnlNo.contBrn = this.matchData.mdBranch
          this.filtersContraJrnlNo.contTranType = this.matchData.mdType
          this.filtersContraJrnlNo.contAcctNo = this.matchData.mdAcctNo
          this.filtersContraJrnlNo.contFund = this.matchData.mdFund
          this.filtersContraJrnlNo.contAcctNoSfx = this.matchData.mdSuffix
          this.filtersContraJrnlNo.actionName = this.action
        }
      }
      this.doContraJrnlNoFilters()
    },
    closeDialog() {
      this.filtersContraJrnlNo.contraJrnlNo = ''
      this.filtersContraJrnlNo.contDocNo = ''
      this.filtersContraJrnlNo.documentNo = ''
      this.$emit('close')
    },
    doClearContraJrnlNoFilters() {
      this.filtersContraJrnlNo.contraJrnlNo = ''
      this.filtersContraJrnlNo.contDocNo = ''
      this.filtersContraJrnlNo.documentNo = ''
      this.fetchContraJrnlNoData()
    },
    doContraJrnlNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryContraJrnlNoFilterForm').then((result) => {
        if (result) {
          this.paginationContraJrnlNo.page = 1
          this.fetchContraJrnlNoData()
        }
      })
    },
    async fetchContraJrnlNoData() {
      const apiUrl = this.$store.state.commons.menu.acctMchDetList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationContraJrnlNo
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filtersContraJrnlNo)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationContraJrnlNo.sortBy, this.paginationContraJrnlNo.sortDesc)
          )
          if (result.data) {
            this.totalItemsContraJrnlNo = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'contraJrnlNoItems', data)
            } else {
              this.$set(this, 'contraJrnlNoItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignContraJrnlNo(data) {
      // Use $emit to call parent GL Account No page method assignGlAcctNo and pass the value
      if (this.action === 'jrnlNo' || this.action === 'jrnlNoTxn') {
        this.$emit('assign-contra-jrnl-no', data.mdJrnl)
      } else if (this.action === 'baseDocNo') {
        this.$emit('assign-base-doc-no', data.mdContDocNo)
      } else if (this.action === 'selDocNo') {
        this.$emit('assign-sel-doc-no', data.mdDocNo)
      }
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    matchData: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
